import './App.css';
import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const testimonials = [
  {
    quote: `When we first started researching natural births, one of my concerns was what my role would be. Chelsie assured me that she would be there to support us and not replace me in the delivery room.`,
    customer: `Alan T.`,
  },
  {
    quote: `She made me feel like I wasn't alone and that my feelings were valid and they mattered... 10/10 recommend Chelsie as your doula to help ease your mind for birth, and to have a friend and someone who listens to you.`,
    customer: `Angel B.`,
  },
  {
    quote: `Chelsie helped me get my dream birth! She was assertive with the nursing staff and she knew how to calm me down using techniques like touch or mantras... Chelsie has a big heart and genuinely wants to help families.`,
    customer: `Daniella B.`,
  },
  {
    quote: `She made sure I was very informed in the options I had and helped me make a more confident decision... She will make sure you feel like you have all the support you need!`,
    customer: `Destiny R.`,
  },
  {
    quote: `Hiring Chelsie as our doula was the BEST thing that could have happened for us!... I felt safe, and she coached me through labor... The support I felt during pregnancy, labor, and postpartum is unmatched.`,
    customer: `Natelie V.`,
  },
  {
    quote: `She supported my family and me in a critical time of need by providing encouragement, compassion, and confidence that put us at ease... I can't express the amount of gratitude I have for her support during this time.`,
    customer: `Christy E.`,
  },
  {
    quote: `Even if you have a supportive spouse / partner for this journey, I would still suggest you hire Chelsie as your Doula!... Her sense of calm radiates through the room, no matter what is going on!`,
    customer: `Lindsey E.`,
  },
  {
    quote: `I couldn't have done my natural hospital birth without her... She supported all of my wishes and helped to advocate for me in the hospital... 100% you should choose Chelsie to walk alongside you.`,
    customer: `Jordan C.`,
  },
  {
    quote: `Chelsie made me feel more confident this go around... She is also just so sweet, it feels like I'm talking to a girlfriend while also feeling confident about her birthing knowledge!`,
    customer: `Katie N.`,
  },
  {
    quote: `Through all the stages of pregnancy and labor she was a huge help with easing my mind... If you want a doula AND someone you can call a friend- look no further.`,
    customer: `Angela S.`,
  },
  {
    quote: `Chelsie's knowledge, expertise and passion for this profession is 10/10. She's extremely supportive but not overbearing and willing to listen as well as advocate for you.`,
    customer: `Amanda K.`,
  },
  {
    quote: `Chelsie walked us through everything and explained the entire process... Best experience ever. It was a true blessing having Chelsie on our side the entire way!`,
    customer: `Zack S.`,
  },
  {
    quote: `Chelsie made me some amazing cookies that help with milk production and MY did they work... I have been able to exclusively breastfeed... which has made postpartum less stressful for me and my baby.`,
    customer: `Shelley P.`,
  },
];

const services = [
  {
    title: 'Prenatal & Birth Planning',
    kicker: 'Feel prepared before labor begins',
    points: [
      'One-on-one childbirth education with evidence-based, unbiased information.',
      'Birth plan support that reflects your wishes, values, and preferences.',
      'A safe space to talk through questions, fears, coping strategies, and options.',
      'Unlimited communication throughout pregnancy and postpartum.',
    ],
  },
  {
    title: 'Labor & Birth Support',
    kicker: 'Continuous support when it matters most',
    points: [
      'On-call support starting at 37 weeks gestation.',
      'Advocacy that protects your voice and birth preferences.',
      'Physical comfort, emotional support, position ideas, and relaxation techniques.',
      'Breastfeeding and postpartum support for up to two hours after birth.',
    ],
  },
  {
    title: 'Postpartum & Breastfeeding',
    kicker: 'Gentle support after baby arrives',
    points: [
      'A postpartum visit within the first few weeks after birth.',
      'Helpful resources for breastfeeding, newborn care, self care, and local support.',
      'Postpartum anxiety and depression awareness and resources.',
      'Homemade lactation cookies gifted at the first postpartum visit.',
    ],
  },
    {
    title: 'Birth Photography',
    kicker: 'Preserve the moments you never want to forget',
    points: [
      'Natural, documentary-style photography during labor, birth, and those first moments with baby.',
      'Respectful, unobtrusive support that honors the privacy and emotion of your birth space.',
      'Images that capture connection, strength, support, and the first details of your baby’s arrival.',
      'A meaningful way to remember your birth story for years to come.',
    ],
  },
    {
    title: 'Childbirth Education Class',
    kicker: 'prepare for birth with confidence',
    points: [
      'Learn what to expect through each stage of labor and birth.',
      'Explore comfort measures, coping tools, and partner support techniques.',
      'Talk through birth preferences, common interventions, and hospital routines.',
      'Ask questions in a calm, supportive space before your big day.',
    ],
  },
  {
    title: 'Homemade Lactation Cookies',
    kicker: 'A nourishing treat for the postpartum season',
    points: [
      'Fresh, homemade lactation cookies made with breastfeeding-supportive ingredients.',
      'A thoughtful postpartum gift to enjoy after birth.',
      'Prepared with care as a comforting way to support nourishment and recovery.',
      'Gluten-free and allergen-free options available upon request.',
    ],
  },


];

const serviceAreas = [
  'Culpeper County',
  'Fauquier County',
  'Madison County',
  'Albemarle County',
  'Prince William County',
  'Loudoun County',
  'Fairfax County',
  'Fredericksburg',
  'Charlottesville',
];

const serviceAreaText = `Serving families around ${serviceAreas.join(', ')}.`;


// To add, remove, or reorder portfolio photos, edit this array.
// The Services preview, Portfolio page, and lightbox all read from this same list,
// so the layout will automatically adapt to the order and number of images here.
const portfolioImages = [
  {
    id: 1,
    src: require('./assets/portfolio/portfolio-12.webp'),
    title: 'Laboring inward',
    category: 'Labor',
    alt: 'Mother kneeling in a birth pool during labor.',
  },
  {
    id: 13,
    src: require('./assets/portfolio/portfolio-09.webp'),
    title: 'Newborn calm',
    category: 'Details',
    alt: 'Close-up portrait of a sleeping newborn wrapped in a blanket.',
  },
    {
    id: 12,
    src: require('./assets/portfolio/portfolio-08.webp'),
    title: 'Room full of love',
    category: 'Connection',
    alt: 'Newborn resting in a hospital bed while family looks on.',
  },
  // {
  //   id: 2,
  //   src: require('./assets/portfolio/portfolio-16.webp'),
  //   title: 'Covered in love',
  //   category: 'First moments',
  //   alt: 'Mother resting beside her newborn after birth.',
  // },
  {
    id: 3,
    src: require('./assets/portfolio/portfolio-01.webp'),
    title: 'Quiet first latch',
    category: 'First moments',
    alt: 'Black and white birth photography of a mother holding her newborn close.',
  },
  {

    id: 4,
    src: require('./assets/portfolio/portfolio-02.webp'),
    title: 'Resting together',
    category: 'First moments',
    alt: 'Mother resting beside her newborn in a hospital bed.',
  },
  // {
  //   id: 8,
  //   src: require('./assets/portfolio/portfolio-05.webp'),
  //   title: 'After the wave',
  //   category: 'Labor',
  //   alt: 'Black and white image of a mother resting during birth support.',
  // },
  {
    id: 5,
    src: require('./assets/portfolio/portfolio-03.webp'),
    title: 'You are here',
    category: 'First moments',
    alt: 'Smiling mother lying in a hospital bed beside her newborn.',
  },
          {
    id: 6,
    src: require('./assets/portfolio/portfolio-14.webp'),
    title: 'First cry',
    category: 'Arrival',
    alt: 'Newborn being welcomed by the birth team immediately after birth.',
  },
  {
    id: 7,
    src: require('./assets/portfolio/portfolio-04.webp'),
    title: 'Family welcome',
    category: 'Connection',
    alt: 'Parents smiling with their newborn shortly after birth.',
  },
  {
    id: 9,
    src: require('./assets/portfolio/portfolio-06.webp'),
    title: 'Tiny details',
    category: 'Details',
    alt: 'Close-up of a newborn hand held gently by an adult hand.',
  },
  //   {
  //   id: 15,
  //   src: require('./assets/portfolio/portfolio-15.webp'),
  //   title: 'Birth story details',
  //   category: 'Details',
  //   alt: 'Placenta and umbilical cord documented as part of a birth story.',
  //   // Mark graphic/sensitive images with isGraphic: true.
  //   // They will stay blurred in the portfolio and lightbox until the visitor chooses to reveal them.
  //   isGraphic: true,
  // },
  // {
  //   id: 10,
  //   src: require('./assets/portfolio/portfolio-07.webp'),
  //   title: 'Relief and joy',
  //   category: 'First moments',
  //   alt: 'Mother smiling in a hospital bed while holding her newborn.',
  // },
    {
    id: 11,
    src: require('./assets/portfolio/portfolio-11.webp'),
    title: 'Skin to skin',
    category: 'First moments',
    alt: 'Mother holding her newborn skin to skin after birth.',
  },
      {
    id: 17,
    src: require('./assets/portfolio/portfolio-17.webp'),
    title: 'Held and seen',
    category: 'Connection',
    alt: 'A woman holding a newborn in a softly lit room.',
  },
  //     {
  //   id: 18,
  //   src: require('./assets/portfolio/portfolio-18.webp'),
  //   title: 'Held and seen',
  //   category: 'Connection',
  //   alt: 'A woman holding a newborn in a softly lit room.',
  // },

      {
    id: 19,
    src: require('./assets/portfolio/portfolio-19.webp'),
    title: 'Held and seen',
    category: 'Connection',
    alt: 'A woman holding a newborn in a softly lit room.',
  },  
  {
    id: 14,
    src: require('./assets/portfolio/portfolio-13.webp'),
    title: 'Supported through it',
    category: 'Labor',
    alt: 'Support person close to a mother during labor.',
  },
  //       {
  //   id: 16,
  //   src: require('./assets/portfolio/portfolio-10.webp'),
  //   title: 'Held and seen',
  //   category: 'Connection',
  //   alt: 'A woman holding a newborn in a softly lit room.',
  // },
      {
    id: 20,
    src: require('./assets/portfolio/portfolio-20.webp'),
    title: 'Held and seen',
    category: 'Connection',
    alt: 'A woman holding a newborn in a softly lit room.',
  },
  {
    id: 21,
    src: require('./assets/portfolio/portfolio-21.webp'),
    title: 'Held and seen',
    category: 'Connection',
    alt: 'A woman holding a newborn in a softly lit room.',
    isGraphic: true,
  },
  {
    id: 22,
    src: require('./assets/portfolio/portfolio-22.webp'),
    title: 'Newborn details',
    category: 'Details',
    alt: 'Close-up portrait of a newborn resting after birth.',
  },
  {
    id: 23,
    src: require('./assets/portfolio/portfolio-23.webp'),
    title: 'Joy at first sight',
    category: 'First moments',
    alt: 'Mother smiling at her newborn immediately after birth.',
  },
  {
    id: 24,
    src: require('./assets/portfolio/portfolio-24.webp'),
    title: 'Supported together',
    category: 'Connection',
    alt: 'A couple supporting one another during labor at home.',
  },
  {
    id: 25,
    src: require('./assets/portfolio/portfolio-25.webp'),
    title: 'Quiet strength',
    category: 'Labor',
    alt: 'Silhouetted parents sharing a quiet moment during labor.',
  },
];


const seoPages = {
  '/': {
    title: 'Birth Doula & Birth Photographer in Culpeper, VA | Bonded Births',
    description: 'Certified birth doula and documentary birth photographer serving Culpeper and surrounding Central and Northern Virginia with pregnancy, labor, birth, and postpartum support.',
    canonical: '/',
  },
  '/services': {
    title: 'Birth Doula Services in Culpeper, VA | Bonded Births',
    description: 'Birth doula services in Culpeper and surrounding Virginia, including prenatal planning, continuous labor support, postpartum support, breastfeeding resources, and childbirth education.',
    canonical: '/services',
    serviceName: 'Birth Doula Services',
    serviceType: 'Birth doula support',
  },
  '/portfolio': {
    title: 'Birth Photography in Culpeper, VA | Bonded Births',
    description: 'Documentary birth photography in Culpeper and surrounding Virginia, capturing labor, birth, newborn details, and first moments with a calm, unobtrusive approach.',
    canonical: '/portfolio',
    serviceName: 'Birth Photography',
    serviceType: 'Documentary birth photography',
  },
  '/aboutme': {
    title: 'Certified Birth Doula in Culpeper, VA | Meet Chelsie',
    description: 'Meet Chelsie Pasley, a certified labor doula serving Culpeper and surrounding Virginia families with evidence-based pregnancy, labor, birth, and postpartum support.',
    canonical: '/aboutme',
  },
  '/contactme': {
    title: 'Contact a Birth Doula & Birth Photographer | Bonded Births',
    description: 'Contact Bonded Births to ask about birth doula support, birth photography, availability, service areas, or a consultation in Culpeper and surrounding Virginia.',
    canonical: '/contactme',
  },
};

const SeoMeta = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.toLowerCase().replace(/\/$/, '') || '/';
    const page = seoPages[path] || seoPages['/'];
    const baseUrl = 'https://bondedbirths.com';
    const canonicalUrl = `${baseUrl}${page.canonical === '/' ? '/' : page.canonical}`;

    document.title = page.title;

    const setMeta = (selector, attribute, value) => {
      const element = document.head.querySelector(selector);
      if (element) element.setAttribute(attribute, value);
    };

    setMeta('meta[name="description"]', 'content', page.description);
    setMeta('meta[property="og:title"]', 'content', page.title);
    setMeta('meta[property="og:description"]', 'content', page.description);
    setMeta('meta[property="og:url"]', 'content', canonicalUrl);
    setMeta('meta[name="twitter:title"]', 'content', page.title);
    setMeta('meta[name="twitter:description"]', 'content', page.description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);

    let routeSchema = document.getElementById('route-service-schema');
    if (page.serviceName) {
      if (!routeSchema) {
        routeSchema = document.createElement('script');
        routeSchema.type = 'application/ld+json';
        routeSchema.id = 'route-service-schema';
        document.head.appendChild(routeSchema);
      }
      routeSchema.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: page.serviceName,
        serviceType: page.serviceType,
        url: canonicalUrl,
        description: page.description,
        provider: { '@id': 'https://bondedbirths.com/#business' },
        areaServed: serviceAreas.map((name) => ({ '@type': 'Place', name })),
      });
    } else if (routeSchema) {
      routeSchema.remove();
    }
  }, [location.pathname]);

  return null;
};


function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SeoMeta />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/AboutMe" element={<AboutMe />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/services" element={<Services />} />
        <Route path="/Portfolio" element={<Portfolio />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/ContactMe" element={<ContactMe />} />
      </Routes>
      <Footer />
      <FloatingLogo />
    </BrowserRouter>
  );
}

const Nav = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`siteNav ${isScrolled ? 'scrolled' : ''}`}>
      <HashLink to="/#home" className="navBrand" aria-label="Bonded Births home">
        <span>Bonded Births LLC</span>
      </HashLink>
      <nav className="navLinks" aria-label="Main navigation">
        <HashLink to="/#testimonials">Testimonials</HashLink>
        <HashLink to="/aboutme">About</HashLink>
        <HashLink to="/services">Services</HashLink>
        <HashLink to="/portfolio">Portfolio</HashLink>
        <HashLink to="/contactme" className="navCta desktopNavCta">Contact</HashLink>
      </nav>
      <HashLink to="/contactme" className="navCta mobileNavCta">Contact</HashLink>
    </header>
  );
};

const Home = () => {
  return (
    <main>
      <section id="home" className="heroSection">
        <div className="heroBackground" aria-hidden="true" />
        <div className="heroContent">
          <h1>Embrace Your Birth.</h1>
          <p className="heroText">
            Compassionate, evidence-based birth doula support and documentary birth photography for families in Culpeper and surrounding Central and Northern Virginia.
          </p>
          <div className="heroActions">
            <HashLink className="primaryButton" to="/contactme">Schedule a consultation</HashLink>
            <HashLink className="secondaryButton" to="/services">Explore services</HashLink>
          </div>
        </div>
      </section>
      {/* <FeaturedTestimonial />
      <IntroSection /> */}
      <Testimonials />
      <div className="chelsieContainer">
        <div className="sectionContainer chelsieFeature">
          <div className="chelsiePortraitWrap">
            <img src={require('./assets/chelsie-portrait.webp')} alt="Chelsie Pasley, certified labor doula" />
          </div>
          <div className="chelsieCopy">
            <p className="eyebrow">Meet Chelsie</p>
            <h3>Your calm, steady support person.</h3>
            <p> 
              Chelsie brings a warm, grounded presence to pregnancy, labor, birth, and postpartum care — helping families feel informed, advocated for, and never alone.
            </p>
            <HashLink className="textLink" to="/aboutme">Learn more about Chelsie</HashLink>
          </div>
        </div>
      </div>
      <ServicesPreview />
      {/* <ServiceAreaSection /> */}

      <PortfolioPreview />
      <ContactPreview />
    </main>
  );
};

const FeaturedTestimonial = () => {
  return (
    <section className="featuredTestimonial" aria-label="Featured testimonial">
      <div className="sectionContainer">
        <div className="featureQuoteCard">
          <div className="featureQuoteMark" aria-hidden="true">“</div>
          <p>
            Chelsie helped me get my dream birth! She was assertive with the nursing staff and she knew how to calm me down using techniques like touch or mantras.
          </p>
          <div className="featureQuoteFooter">
            <span>Daniella B.</span>
            <HashLink to="/#testimonials">Read more kind words</HashLink>
          </div>
        </div>
      </div>
    </section>
  );
};

const IntroSection = () => {
  return (
    <section className="section introSection">
      <div className="sectionContainer introGrid">
        <div>
          <p className="eyebrow">Supported, informed, empowered</p>
          <h2>Birth support that feels calm, personal, and deeply reassuring.</h2>
        </div>
        <div className="introCopy">
          <p>
            At Bonded Births LLC, every family’s wishes and preferences are treated as the foundation of a positive and empowering birth experience. Chelsie provides compassionate, unbiased, evidence-based care that honors your individuality.
          </p>
          <p>
            Whether you are planning a hospital birth, home birth, VBAC, cesarean, medicated birth, or unmedicated birth, you deserve steady support and clear information every step of the way.
          </p>
        </div>
      </div>


    </section>
  );
};

const ServicesPreview = () => {
  return (
    <section className="section servicesPreview">
      <div className="sectionContainer">
        <div className="sectionHeading centered">
          <p className="eyebrow">Doula services</p>
          <h2>Guidance before, during, and after birth.</h2>
        </div>
        <div className="previewGrid">
                <article className="previewCard">
                <span>Most Popular Package</span>
                <h3>Bundle of Joy</h3>
                <p>Premium package including Prenatal & Birth Planning, Labor & Birth Support, and Postpartum & Breastfeeding Services</p>
              </article>         
                            <article className="previewCard">
                <span>Preserve the moments</span>
                <h3>Birth Photography</h3>
                <p>Natural, documentary-style photography during labor, birth, and those first moments with baby.</p>
              </article>     
              <article className="previewCard">
                <span>A postpartum treat</span>
                <h3>Homemade Lactation Cookies</h3>
                <p>Fresh, homemade lactation cookies made with breastfeeding-supportive ingredients.</p>
              </article>

        </div>
        <div className="centerButton">
          <HashLink className="secondaryButton dark" to="/services">See all services</HashLink>
        </div>
      </div>
    </section>
  );
};

const Testimonials = () => {
  const [showAll, setShowAll] = useState(false);
  const visibleTestimonials = showAll ? testimonials : testimonials.slice(0, 6);

  return (
    <section className="section testimonialsSection" id="testimonials">
      <div className="sectionContainer">
        <div className="sectionHeading centered">
          <img className="stars" src={require('./assets/5stars.png')} alt="Five star reviews" />
          <p className="eyebrow">Client testimonials</p>
          <h2>Families remember how supported they felt.</h2>
          <p>
            Families remember feeling heard and cared for. Kind words from families Chelsie has supported.
          </p>
        </div>
        <div className={`testimonialGrid ${showAll ? 'expanded' : ''}`}>
          {visibleTestimonials.map((testimonial) => (
            <blockquote className="testimonialCard" key={testimonial.customer}>
              <p>{testimonial.quote}</p>
              <cite>{testimonial.customer}</cite>
            </blockquote>
          ))}
        </div>
        <div className="centerButton testimonialToggleWrap">
          <button
            className="secondaryButton dark testimonialToggle"
            type="button"
            onClick={() => setShowAll((current) => !current)}
          >
            {showAll ? 'Show fewer testimonials' : 'Read more testimonials'}
          </button>
        </div>
      </div>
    </section>
  );
};

const ServiceAreaSection = () => {
  return (
    <section className="section serviceAreaSection" aria-label="Service area">
      <div className="sectionContainer">
        <div className="contactCtaCard">
          <div>
            <p className="eyebrow">Service area</p>
            <h2>Doula support across Culpeper and surrounding Virginia communities.</h2>
            <p>{serviceAreaText}</p>
          </div>
          <HashLink className="secondaryButton dark" to="/contactme">Ask about your area</HashLink>
        </div>
      </div>
    </section>
  );
};

const ContactPreview = () => {
  return (
    <section className="section contactPreview">
      <div className="sectionContainer contactCtaCard">
        <div>
          <p className="eyebrow">Start the conversation</p>
          <h2>Ready to talk through your birth support options?</h2>
          <p>Send a message to ask questions, check availability, or schedule a consultation in your area.</p>
        </div>
        <HashLink className="primaryButton" to="/contactme">Contact Chelsie</HashLink>
      </div>
    </section>
  );
};

const AboutMe = () => {
  return (
    <main className="pageShell aboutPage">
      <section className="pageHero smallHero">
        <p className="eyebrow">Meet your doula</p>
        <h1>Compassionate support rooted in advocacy and empowerment.</h1>
          <p>
            Every family deserves to feel informed, respected, and supported. My care is centered around your voice, your values, and the kind of birth experience you want to carry with you.
          </p>
      </section>

      <section className="sectionContainer aboutStack aboutBalancedStack">

        <article className="aboutCard aboutBalancedCard imageRight aboutPortraitCard">
          <div className="aboutCardText">
            <p className="eyebrow">My philosophy</p>
            <h2>Your birth preferences matter.</h2>
            <p>
              Welcome to Bonded Births Doula Services, where the wishes of your family are not only respected, but appreciated. My name is Chelsie Pasley. I am a certified labor doula committed to providing nurturing, unbiased evidence-based care to growing families through pregnancy, childbirth, and the early postpartum period.
            </p>
            <p>
              With Bonded Births, you will feel empowered and confident in your ability to give birth your way, while feeling loved and supported through the entire journey! Your family is your priority and welcoming a new baby in to the world is life changing. As a mother myself, I understand that the right support can truly make all the difference.
            </p>
          </div>
          <img
            className="aboutChelsiePortrait"
            src={require('./assets/chelsie-portrait.webp')}
            alt="Chelsie Pasley, certified labor doula and birth photographer"
          />
        </article>

        <article className="aboutCard aboutBalancedCard imageLeft aboutPhotoCard">
          <img className="aboutStoryPhoto" src={require('./assets/doula-support-birth.webp')} alt="Chelsie offering compassionate support to a mother holding her newborn in the hospital" loading="lazy" />
          <div className="aboutCardText">
            <p className="eyebrow">Why I became a doula</p>
            <h2>I wanted to become the kind of support I needed.</h2>
  <p>
I am happily married with two crazy, silly daughters. Before becoming a doula, I worked as a social worker with children and families in and out of the child welfare system. My background in social work, advocacy, and empowerment helps me offer a judgment-free, understanding presence to the women and families I support.
    </p>
    <p>
After my own births, I realized how deeply I needed the emotional and psychological postpartum support I never received. Motherhood is transformative, but it is not always easy or pretty. My goal as a doula is to help moms feel seen, heard, loved, and supported through all the emotions that come with the sacred transition into motherhood.
    </p>
          </div>
        </article>

        <article className="aboutCard aboutBalancedCard imageRight aboutPhotoCard">
          <div className="aboutCardText">
            <p className="eyebrow">My birth stories</p>
            <h2>My own births shaped how I support other families.</h2>
  <p>
In both of my births, I was induced due to high blood pressure, which left me feeling like some of the choice and control had been taken from me. Although induction was not part of my birth preferences, the support and comfort my nurses provided helped me have two healthy, natural births, and I am so grateful for that.
    </p>
    <p>
After my first birth, I struggled with postpartum anxiety and depression and often felt alone in my new motherhood journey. It was the combination of amazing physical and emotional support during my labors and the lack of support postpartum that inspired me to become a doula. Those experiences helped me understand how much compassionate support matters, and they inspired me to offer that same care to others during their births.
    </p>
          </div>
          <img className="aboutStoryPhoto" src={require('./assets/my-birth-story.webp')} alt="A tender black-and-white moment of a mother cradling her newborn after birth" loading="lazy" />
        </article>

        <article className="aboutCard aboutBalancedCard imageLeft aboutFamilyCard">
          <img className="aboutFamilyPhoto" src={require('./assets/chelsie-family.webp')} alt="Chelsie smiling outdoors with her husband and two daughters" loading="lazy" />
          <div className="aboutCardText">
            <p className="eyebrow">The heart behind Bonded Births</p>
            <h2>Family is at the heart of what I do.</h2>
            <p>
              When I'm not supporting growing families, I'm making memories with my own husband and our two daughters. Being a mother has shaped the way I listen, care, and show up for others.
            </p>
            <p>
              I know every family's journey is different. My hope is that you feel respected, encouraged, and genuinely cared for as you welcome your little one.
            </p>
          </div>
        </article>
      </section>
    </main>
  );
};

const Services = () => {
  const bundleServices = services.slice(0, 3);
  const optionalServices = services.slice(3);

  const renderServiceCard = (service, index, type) => (
    <article className={`serviceDetailCard ${type === 'bundle' ? 'bundleServiceCard' : 'optionalServiceCard'}`} key={service.title}>
      <div className="serviceNumber">0{index + 1}</div>
      <div>
        <div className="serviceCardHeadingRow">
          <p className="eyebrow">{service.kicker}</p>
          <span className={`serviceBadge ${type === 'bundle' ? 'bundleBadge' : 'optionalBadge'}`}>
            {type === 'bundle' ? 'Bundle of Joy' : 'Optional'}
          </span>
        </div>
        <h2>{service.title}</h2>
        <ul>
          {service.points.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
        {service.title === 'Birth Photography' && (
          <div className="servicePortfolioPrompt">
            <HashLink to="/portfolio">Open full portfolio</HashLink>
          </div>
        )}
      </div>
    </article>
  ); 

  return (
    <main className="pageShell servicesPage" id="services">
      <section className="pageHero">
        <p className="eyebrow">Services</p>
        <h1>Birth doula support designed around your family’s needs.</h1>
        <p>
          Whether you want steady support through pregnancy, labor, birth, and postpartum, or help with one specific part of your journey, services can be shaped around what feels most supportive for you. Bonded Births provides birth doula services for families in Culpeper and surrounding Central and Northern Virginia.
        </p>
      </section>

      <section className="sectionContainer servicesPackageLayout">
        <div className="bundleJoyCallout">
          <div>
            <p className="eyebrow">Most popular package</p>
            <h2>Bundle of Joy</h2>
            <p>
              The Bundle of Joy package brings the first three services together so your family has support before, during, and after baby arrives.
            </p>
          </div>
          <ul className="bundleIncludedList" aria-label="Services typically included in the Bundle of Joy package">
            <li>Prenatal & Birth Planning</li>
            <li>Labor & Birth Support</li>
            <li>Postpartum & Breastfeeding</li>
          </ul>
        </div>

        <div className="serviceGroup">
          {/*<div className="serviceGroupHeading">
            <p className="eyebrow">Included together most often</p>
             <h2>Core doula support</h2> 
            <p>
              These three services are designed to work together as the Bundle of Joy package, but each one can also be booked individually.
            </p>
          </div>*/}
          <div className="servicesGridFull serviceGroupGrid">
            {bundleServices.map((service, index) => renderServiceCard(service, index, 'bundle'))}
          </div>
        </div>

        <div className="serviceGroup">
          <div className="serviceGroupHeading optionalGroupHeading">
            <p className="eyebrow">Optional services</p>
            {/* <h2>Add-ons or individual support</h2> */}
            <p>
              Homemade lactation cookies and birth photography can be added to a Bundle of Joy package or booked separately.
            </p>
          </div>
          <div className="servicesGridFull serviceGroupGrid optionalServicesGrid">
            {optionalServices.map((service, index) => renderServiceCard(service, index + bundleServices.length, 'optional'))}
          </div>
        </div>
      </section>


      <section className="sectionContainer servicesClosingSection">
        <div className="aLaCarteNote">
          <p>
            Need something different? Any service above can be booked individually, added to a package, or discussed during a consultation.
          </p>
          <HashLink className="primaryButton" to="/contactme">Ask about the best fit</HashLink>
        </div>
      </section>
    </main>
  );
};


const PortfolioPreview = () => {
  const previewImageIds = [
  6, 2, 3, 11, 8, 12, 1
];

const previewImages = previewImageIds
  .map((id) => portfolioImages.find((image) => image.id === id))
  .filter(Boolean);

  return (
    <section className="section portfolioPreviewSection" id="portfolio-preview" aria-label="Birth photography portfolio preview">
      <div className="sectionContainer portfolioPreviewShell">
        <div className="portfolioPreviewCopy">
          <p className="eyebrow">Birth photography</p>
          <h2>
            Documentary birth photography to preserve your birth story
          </h2>
          <p>
            From labor support to baby’s first moments. Open the full portfolio to browse every photo larger.
          </p>
          <HashLink className="primaryButton" to="/portfolio">View full portfolio</HashLink>
        </div>
        <div className="portfolioPreviewFan" aria-hidden="true">
          {previewImages.map((image, index) => (
            <img src={image.src} alt="" key={`${image.title}-${index}`} style={{ '--offset': index, '--drop': index % 2 }} />
          ))}
        </div>
      </div>
    </section>
  );
};

const Portfolio = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [revealedGraphicImageIds, setRevealedGraphicImageIds] = useState(() => new Set());
  const activeImage = activeIndex === null ? null : portfolioImages[activeIndex];
  const introImages = portfolioImages.slice(0, 3);

  const isGraphicImageRevealed = useCallback((image) => {
    if (!image?.isGraphic) return true;
    return revealedGraphicImageIds.has(image.id);
  }, [revealedGraphicImageIds]);

  const revealGraphicImage = useCallback((imageId) => {
    setRevealedGraphicImageIds((currentIds) => {
      const nextIds = new Set(currentIds);
      nextIds.add(imageId);
      return nextIds;
    });
  }, []);

  const activeImageIsRevealed = activeImage ? isGraphicImageRevealed(activeImage) : true;

  const showImage = useCallback((nextIndex) => {
    const total = portfolioImages.length;
    setActiveIndex((nextIndex + total) % total);
  }, []);

  useEffect(() => {
    if (activeIndex === null) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setActiveIndex(null);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [activeIndex, showImage]);

  return (
    <main className="pageShell portfolioPage" id="portfolio">
      <section className="pageHero portfolioHero">
        <p className="eyebrow">Birth photography portfolio</p>
        <h1>Documentary birth photography for labor, birth, and the first moments after.</h1>
        <p>
          Images that capture connection, strength, support, and the first details of your baby’s arrival. Browse the full collection, then open any image for a larger view. Birth photography is available for families in Culpeper and surrounding Central and Northern Virginia
        </p>
      </section>

      <section className="sectionContainer portfolioGalleryWrap" aria-label="Interactive birth photography gallery">
        {/* <div className="portfolioIntroPanel">
          <div className="portfolioIntroCopy">
            <p className="eyebrow">Full birth photography gallery</p>
            <h2>A gentle look through the whole story.</h2>
            <p>
              Browse every portfolio image together, then click any photo to open it larger. No filters or captions needed — the gallery is meant to feel simple, warm, and easy to explore.
            </p>
            <div className="portfolioIntroChips" aria-label="Portfolio themes">
              <span>Labor support</span>
              <span>Baby’s arrival</span>
              <span>First moments</span>
            </div>
          </div>
          <div className="portfolioIntroVisual" aria-hidden="true">
            {introImages.map((image, index) => (
              <img src={image.src} alt="" key={`portfolio-intro-${index}`} style={{ '--introOffset': index }} />
            ))}
          </div>
        </div> */}

        <div className="portfolioMasonryGrid">
          {portfolioImages.map((image, index) => {
            const graphicImageHidden = image.isGraphic && !isGraphicImageRevealed(image);

            return (
              <button
                className={`portfolioMasonryCard portfolioCard${(index % 5) + 1}${graphicImageHidden ? ' graphicImageHidden' : ''}`}
                type="button"
                key={`${image.title}-${index}`}
                onClick={() => setActiveIndex(index)}
                aria-label={graphicImageHidden ? `Open graphic image preview for ${image.title}` : `Open ${image.title}`}
              >
                <img src={image.src} alt={image.alt} />
                {graphicImageHidden && (
                  <span className="graphicThumbnailNotice" aria-hidden="true">
                    <span>Graphic image</span>
                    <strong>Open to view</strong>
                  </span>
                )}
              </button>
            );
          })}
        </div>

        <div className="portfolioClosingSection">
          <div className="aLaCarteNote">
            <p>
              Ready to preserve your birth story? Birth photography can be added to a package or discussed during a consultation.
            </p>
            <HashLink className="primaryButton" to="/contactme">Contact Chelsie</HashLink>
          </div>
        </div>
      </section>

      {activeImage && (
        <div className="portfolioLightbox" role="dialog" aria-modal="true" aria-label="Expanded portfolio image" onClick={() => setActiveIndex(null)}>
          <div className={`portfolioLightboxInner${activeImage.isGraphic && !activeImageIsRevealed ? ' graphicImageHidden' : ''}`} onClick={(event) => event.stopPropagation()}>
            <button className="lightboxClose" type="button" onClick={() => setActiveIndex(null)} aria-label="Close larger image">×</button>
            <button className="lightboxArrow previous" type="button" onClick={() => showImage(activeIndex - 1)} aria-label="Previous image">‹</button>
            <div className="lightboxImageFrame">
              <img src={activeImage.src} alt={activeImage.alt} />
              {activeImage.isGraphic && !activeImageIsRevealed && (
                <div className="graphicLightboxNotice" role="group" aria-label="Graphic image warning">
                  <p className="eyebrow">Graphic birth image</p>
                  <h2>Would you like to view this image?</h2>
                  <p>{activeImage.graphicWarning || 'This portfolio image includes graphic birth-related details.'}</p>
                  <button className="primaryButton" type="button" onClick={() => revealGraphicImage(activeImage.id)}>
                    Show image
                  </button>
                </div>
              )}
            </div>
            <button className="lightboxArrow next" type="button" onClick={() => showImage(activeIndex + 1)} aria-label="Next image">›</button>
          </div>
        </div>
      )}
    </main>
  );
};

const ContactMe = () => {
  const [phoneNum, setPhoneNum] = useState('');

  const setPhoneNumber = (e) => {
    const raw = e.target.value.replace(/\D/g, '').slice(0, 10);
    let formattedNumber = raw;

    if (raw.length > 6) {
      formattedNumber = `(${raw.slice(0, 3)}) ${raw.slice(3, 6)}-${raw.slice(6)}`;
    } else if (raw.length > 3) {
      formattedNumber = `(${raw.slice(0, 3)}) ${raw.slice(3)}`;
    } else if (raw.length > 0) {
      formattedNumber = raw;
    }

    setPhoneNum(formattedNumber);
  };

  return (
    <main id="contactme" className="pageShell contactPage">
      <section className="sectionContainer contactGrid">
        <div className="contactIntro">
          <p className="eyebrow">Contact</p>
          <h1>Send me a message.</h1>
          <p>
            Tell me a little about your due date, birth location, and whether you are looking for doula support, birth photography, or both. I’ll follow up as soon as I can.
          </p>
          <p>
            <strong>Service area:</strong> {serviceAreaText}
          </p>
          <div className="directContact">
            <a href="tel:5408788988">540-878-8988</a>
            <a href="mailto:chelsie.pasley@gmail.com">chelsie.pasley@gmail.com</a>
          </div>
          <div className="contacticons">            <HashLink to="https://www.instagram.com/bonded.births/" target="_blank"><img src={require('./assets/instagramblue.png')} alt="Bonded Births Instagram" /></HashLink>

            <HashLink to="https://www.facebook.com/people/Bonded-Births-Doula-Services/61550988598253/" target="_blank"><img src={require('./assets/facebookblue.png')} alt="Bonded Births Facebook" /></HashLink>
            <HashLink target="_blank" to="tel:540-878-8988"><img src={require('./assets/phoneblue.png')} alt="Call Bonded Births" /></HashLink>
            <HashLink target="_blank" to="mailto:chelsie.pasley@gmail.com"><img src={require('./assets/emailblue.png')} alt="Email Bonded Births" /></HashLink>
          </div>
        </div>

        <form className="contactForm" name="contact" method="POST">
          <input type="hidden" name="form-name" value="contact" />
          <label>
            Name
            <input required name="name" type="text" autoComplete="name" />
          </label>
          <label>
            Email
            <input required name="email" type="email" autoComplete="email" />
          </label>
          <label>
            Phone
            <input required name="phone" type="tel" autoComplete="tel" onChange={setPhoneNumber} value={phoneNum} />
          </label>
          <label>
            How did you hear about us?
            <input required name="reference" type="text" />
          </label>
          <label>
            Your message
            <textarea required name="message" rows="5" placeholder="Birth location, due date, questions, or what support you’re looking for..." />
          </label>
          <button type="submit" className="primaryButton formButton">Send message</button>
        </form>
      </section>
    </main>
  );
};

const FloatingLogo = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isVisible, setIsVisible] = useState(!isHomePage);
  const [isOverFooter, setIsOverFooter] = useState(false);

  useEffect(() => {
    const updateFloatingLogo = () => {
      const isHome = window.location.pathname === '/';
      setIsVisible(!isHome || window.scrollY > 4);

      const footer = document.querySelector('.footerContainer');
      if (!footer) {
        setIsOverFooter(false);
        return;
      }

      const footerTop = footer.getBoundingClientRect().top;
      const logoSwitchPoint = window.innerHeight - 96;
      setIsOverFooter(footerTop <= logoSwitchPoint);
    };

    updateFloatingLogo();
    window.addEventListener('scroll', updateFloatingLogo, { passive: true });
    window.addEventListener('resize', updateFloatingLogo);

    return () => {
      window.removeEventListener('scroll', updateFloatingLogo);
      window.removeEventListener('resize', updateFloatingLogo);
    };
  }, [location.pathname, isHomePage]);

  const logoSrc = isOverFooter
    ? require('./assets/BondedBirths1.png')
    : require('./assets/BondedBirths1blue.png');

  return (
    <HashLink
      className={`floatingLogo ${isVisible ? 'visible' : ''}`}
      to="/#home"
      aria-label="Back to Bonded Births home"
    >
      <img src={logoSrc} alt="Bonded Births logo" />
    </HashLink>
  );
};

const Footer = () => {
  return (
    <footer className="footerContainer">
      <div className="footerInner">
        <div>
          <h2>Bonded Births</h2>
          <p>Compassionate birth doula support and documentary birth photography for pregnancy, labor, birth, and postpartum.</p>
          <p>Serving Culpeper, Warrenton, Fredericksburg, Charlottesville, and surrounding Central/Northern Virginia communities.</p>
        </div>
        <div className="footerLinks">
          <HashLink to="/#home">Home</HashLink>
          <HashLink to="/#testimonials">Testimonials</HashLink>
          <HashLink to="/aboutme">About</HashLink>
          <HashLink to="/services">Services</HashLink>
          <HashLink to="/portfolio">Portfolio</HashLink>
          <HashLink to="/contactme">Contact</HashLink>
        </div>
        <div className="footerContact">
          <a href="mailto:chelsie.pasley@gmail.com">Chelsie.Pasley@gmail.com</a>
          <a href="tel:5408788988">540-878-8988</a>
          <div className="social">
            <a href="https://www.instagram.com/bonded.births/" target="_blank" rel="noreferrer"><img src={require('./assets/instagram.png')} alt="Instagram" /></a>
            <a href="https://www.facebook.com/people/Bonded-Births-Doula-Services/61550988598253/" target="_blank" rel="noreferrer"><img src={require('./assets/facebook.png')} alt="Facebook" /></a>
          </div>
        </div>
      </div>
      <p className="createdby">Website by <a href="http://onebytewonders.com" target="_blank" rel="noreferrer">OneByteWonders</a></p>
    </footer>
  );
};

export default App;
